<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="4">
          <el-scrollbar>
            <h1>评等指标</h1>
            <el-menu border class="el-menu" @select="selectMenu">
              <template v-for="column in normItems" :key="column.normId">
                <el-submenu>
                  <el-menu-item :index="column.normId">
                    <el-icon><icon-menu /></el-icon>
                    <span>{{ column.normName }}</span>
                  </el-menu-item>
                  <template
                    v-for="subColumn in column.children"
                    :key="subColumn.normId"
                  >
                    <el-menu-item :index="subColumn.normId" class="sub-norm">
                      <el-icon><icon-menu /></el-icon>
                      <span>{{ "\xa0\xa0\xa0" }}{{ subColumn.normName }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-menu>
          </el-scrollbar>
        </el-col>

        <el-col :span="19" :offset="1">
          <div class="btn-group">
            <el-button type="primary" @click="handleAdd">添加</el-button>
          </div>

          <el-table
            class="table"
            :data="rateScoreList"
            @row-dblclick="rowDoubleClick"
          >
            <el-table-column prop="id" label="指标序号" width="180">
            </el-table-column>
            <el-table-column prop="rateName" label="等次名称" width="180">
              <template #default="scope">
                <el-input
                  v-if="scope.row.isOk"
                  v-model="scope.row.rateName"
                ></el-input>
                <span v-else>{{ scope.row.rateName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rateScore" label="等次分数" width="180">
              <template #default="scope">
                <el-input
                  v-if="scope.row.isOk"
                  v-model="scope.row.rateScore"
                ></el-input>
                <span v-else>{{ scope.row.rateScore }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="upperLimit" label="上限比例" width="180">
              <template #default="scope">
                <el-input
                  v-if="scope.row.isOk"
                  v-model="scope.row.upperLimit"
                ></el-input>
                <span v-else>{{ scope.row.upperLimit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="operation" label="操作" width="200">
              <template #default="scope">
                <el-popconfirm
                  title="确认删除?"
                  @confirm="handleDelete(scope.$index, scope.row)"
                  confirm-button-text="是"
                  cancel-button-text="否"
                >
                  <template #reference>
                    <el-button type="text">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <p class="table-note">
            *双击数据行进行修改，等次名称写“好”、“较好”等
          </p>

          <div class="btn-save">
            <el-button type="primary" @click="handleSave">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import RateManage from "../api/RateManage";
export default RateManage;
</script>

<style scoped lang="scss">
.btn-group {
  text-align: right;
}
.el-menu {
  height: 700px;
}
.table-note {
  font-size: 14px;
  text-align: left;
}

.table {
  margin-top: 20px;
}

.sub-norm {
  height: 40px;
}

.btn-save {
  text-align: left;
}
</style>